// src/js/components/search-drawer.js
var SearchDrawerMain = class extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector("[search-drawer-js]");
    this.drawerClose = this.querySelector("[drawer-close]");
    this.drawerOpener = document.querySelector("[toggle-search-drawer]");
    this.overlay = this.querySelector(".overlay-body--layer");
    this.input = this.querySelector(".search__input");
    if (!this.drawer) return;
    this.drawer.inert = true;
    this.drawer.setAttribute("aria-hidden", "true");
    this.drawerOpener?.setAttribute("aria-controls", this.drawer.id);
    this.drawerOpener?.setAttribute("aria-expanded", "false");
    this.drawerOpener?.setAttribute("aria-haspopup", "dialog");
    this.overlay?.addEventListener("click", () => this.closeDrawer());
    this.drawerClose?.addEventListener("click", () => this.closeDrawer());
    this.drawerOpener?.addEventListener("click", () => this.toggleDrawer());
    this.drawer.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        this.closeDrawer();
      }
      if (event.key !== "Tab") return;
      const items = [...this.drawer.querySelectorAll("a[href], button, input, select, textarea, [tabindex]")].filter((item) => item.tabIndex >= 0 && !item.disabled && item.getClientRects().length && getComputedStyle(item).visibility !== "hidden");
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
  }
  toggleDrawer() {
    if (this.drawer.classList.contains("active")) this.closeDrawer();
    else this.openDrawer();
  }
  openDrawer() {
    this.returnFocus = document.activeElement;
    this.previousOverflow = document.documentElement.style.overflow;
    this.drawer.inert = false;
    this.drawer.removeAttribute("aria-hidden");
    this.drawer.classList.add("active");
    this.overlay?.classList.add("active");
    this.drawerOpener?.setAttribute("aria-expanded", "true");
    document.documentElement.style.overflow = "hidden";
    this.input?.focus();
  }
  closeDrawer() {
    if (!this.drawer.classList.contains("active")) return;
    this.drawer.classList.remove("active");
    this.overlay?.classList.remove("active");
    this.drawerOpener?.setAttribute("aria-expanded", "false");
    document.documentElement.style.overflow = this.previousOverflow || "";
    (this.returnFocus?.isConnected ? this.returnFocus : this.drawerOpener)?.focus();
    this.drawer.inert = true;
    this.drawer.setAttribute("aria-hidden", "true");
  }
};
customElements.define("search-drawer-main", SearchDrawerMain);
